import { createContext, useContext, useState, useEffect, ReactNode } from "react";
import { setUserAuth,
    removeUserAuth,
    getUserAuthData,
    getCompanyInfo,
    getStoragedCurrentOperator,
    setStorageCurrentOperator,
setDefaultAtag} from "./authHelper";
import { f7, f7ready } from "framework7-react";
import axios from "axios";

interface AuthContextType {
    user: any;
    authUserData: any;
    loading: boolean;
    login: (username: string, password: string) => Promise<boolean>;
    logout: () => void;
}

const AuthContext = createContext<AuthContextType | null>(null);

export const useAuth = (): AuthContextType => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error("useAuth must be used within an AuthProvider");
    }
    return context;
};

export const AuthProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [user, setUser] = useState<any>(null);
    const [loading, setLoading] = useState<boolean>(true);
    let authUserData = getUserAuthData();
    const storedOperatorValue = getStoragedCurrentOperator();
    const getOperatorData = async () => {
        try {
            const response = await axios.get(`/api/users/me`);
            setUserAuth(response.data);
            setUser(response.data);
            if (storedOperatorValue) {
                getCompanyInfo(storedOperatorValue);
            } else {
                getCompanyInfo(response.data.operators[0]);
                setStorageCurrentOperator(response.data.operators[0]);
                setDefaultAtag(response.data.operators[0] + 'Atag');
            }
        } catch (error) {
            console.error("Check getOperatorData method:", error);
            logout();
        } finally {
            setLoading(false);
        }
    };

    const login = async (username: string, password: string): Promise<boolean> => {
        try {
            const formData = new URLSearchParams();
            formData.append("username", username);
            formData.append("password", password);

            const response = await axios.post("/api/auth/login", formData, {
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                },
            });

            if (response.status === 200 || response.status === 204) {
                await getOperatorData();
                return true;
            }
        } catch (error) {
            console.error("Login error:", error);
            return false;
        }

        return false;
    };


 const logout = () => {
        setUser(null);
        removeUserAuth();
        f7ready(() => {
            f7.views.main.router.navigate("/auth/");
        });
    };

    useEffect(() => {
        if (!user && authUserData) {
            getOperatorData();
        } else {
            setLoading(false);
        }
    }, [user, authUserData, getOperatorData]);


    return (
        <AuthContext.Provider value={{ user, authUserData, loading, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};
